<script setup lang="ts">
import { useToast } from '@/components/ui/toast/use-toast'

const { user } = useUser()
const { toast } = useToast()

const form = useForm({
	method: 'PUT',
	url: route('user-profile-information.update'),
	fields: {
		name: user.value.name,
		email: user.value.email,
	},
	errorBag: 'updateProfileInformation',
	reset: false,
})

const verifyForm = useForm({
	method: 'POST',
	url: route('verification.send'),
	fields: {},
	hooks: {
		success: () => {
			if (user.value.email_verified_at !== null) {
				return
			}

			toast({
				title: t('app.verification_link_sent'),
				variant: 'successful',
			})
		},
	},
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper>
		<user-submenu />

		<ui-form variant="settings" @submit.prevent="form.submit">
			<ui-form-settings-item>
				<template #label>
					<ui-label for="name">
						{{ t('validation.attributes.name') }}
					</ui-label>
				</template>

				<ui-input
					id="name"
					v-model="form.fields.name"
					required
					autofocus
				/>
				<ui-form-error :message="form.errors.name" />
			</ui-form-settings-item>

			<ui-form-settings-item>
				<template #label>
					<ui-label for="email">
						{{ t('validation.attributes.email') }}
					</ui-label>
				</template>

				<template #description>
					{{ t('forms.profile_information.email_description') }}
				</template>

				<ui-input
					id="email"
					v-model="form.fields.email"
					required
					autofocus
					type="email"
				/>
				<ui-form-error :message="form.errors.email" />

				<div v-if="user.email_verified_at === null" class="bg-destructive/10 text-destructive mt-4 flex flex-col gap-3 rounded p-3">
					<div class="text-sm">
						{{ t('app.email_not_verified') }}
					</div>

					<ui-button
						variant="outline"
						:loading="verifyForm.processing"
						class="w-fit"
						@click="verifyForm.submit"
					>
						{{ t('app.buttons.resend_verification_email') }}
						<template #icon>
							<i-ph-arrow-right />
						</template>
					</ui-button>
				</div>
			</ui-form-settings-item>

			<ui-separator />

			<ui-button :loading="form.processing" class="w-fit" @click="form.submit">
				{{ t('app.buttons.save') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>
		</ui-form>
	</content-wrapper>
</template>
